<template>
  <div style="margin-top: 1%; padding-bottom: 2%">
    Dear A. Jones,<br /><br />

    The head office has promised that the financial resources to build the
    transmission towers are available as of now. This means that all we have to
    do is find a suitable company to carry out the construction of our 5G
    transmission towers. The only basic conditions that the head office has set
    for us are as follows:<br /><br />

    Cost of the project: maximum $44,00,00,000.<br /><br />

    Completion of the construction project by: November 2023 at the latest.<br /><br /><br />

    Best regards<br />

    Mary Locke
  </div>
</template>

<script>
import "./styles.css";

export default {
  props: {
    parentFunction: Function,
  },
};
</script>
